export const PHONE_NUMBER_DISPLAY = "+49 1575 2195743";
export const PHONE_NUMBER_E164 = "+4915752195743";
export const TEL_URL = "tel:+4915752195743";
export const WHATSAPP_URL = "https://wa.me/4915752195743";
